import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { pedir } from './api';

/**
 * Una consulta GET a la API del Centro. La clave lleva la ruta y los parámetros, así que
 * `refrescar('/appliances')` alcanza para volver a pedir la lista y el detalle abierto.
 */
export function useConsulta<T>(
  ruta: string,
  opciones: Omit<UseQueryOptions<T>, 'queryKey' | 'queryFn'> = {},
  consulta?: Record<string, string | number | boolean | undefined>,
) {
  return useQuery<T>({
    queryKey: [ruta, consulta ?? null],
    queryFn: ({ signal }) => pedir<T>(ruta, { senal: signal, consulta }),
    ...opciones,
  });
}
